import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllBranchesData,
  GetAllBranchList,
  GetIndividualBranch,
} from "./branchApi";

//       dispatch(setIsExcelValid(false));
const barnchSlice = createSlice({
  name: "branch",
  initialState: {
    branchListData: [],
    individualBranch: [],
    validationErrors: [],
    allBranchesData: [],
    isExcelValid: false,
    excelData: [],
    tableData: [],
    branchFilters: {
      name: "",
      cchi: "",
      nphies_id: "",
    },
  },
  reducers: {
    setExcelData: (state, action) => {
      state.excelData = action.payload;
    },
    setValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setIsExcelValid: (state, action) => {
      state.isExcelValid = action.payload;
    },
    deleteRow: (state, action) => {
      const rowNumToDelete = action.payload;
      state.tableData = state.tableData.filter(
        (row) => row.rowNum !== rowNumToDelete
      );
    },
    updateRowData: (state, action) => {
      const { rowNum, updatedData, isValid } = action.payload;
      state.tableData = state.tableData.map((row) =>
        row.rowNum === rowNum
          ? {
              ...updatedData,
              rowNum,
              isValid,
              errors: isValid ? [] : row.errors,
            }
          : row
      );
    },
    handleBranchFilter: (state, action) => {
      state.branchFilters[action?.payload?.check] = action?.payload?.value;
    },
    handleBranchReset: (state, _) => {
      state.branchFilters = {
        name: "",
        cchi: "",
        nphies_id: "",
      };
    },
    resetIndividual: (state, _) => {
      state.individualBranch = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllBranchList.fulfilled, (state, action) => {
        state.branchListData = action.payload?.data?.branch_details;
      })
      .addCase(GetIndividualBranch.fulfilled, (state, action) => {
        state.individualBranch = action.payload?.data?.branch_data;
      })
      .addCase(GetAllBranchesData.fulfilled, (state, action) => {
        state.allBranchesData = action.payload?.data?.branch_sel_data;
      });
  },
});

export const {
  handleBranchFilter,
  handleBranchReset,
  setTableData,
  setIsExcelValid,
  updateRowData,
  setValidationErrors,
  setExcelData,
  resetIndividual,
  deleteRow,
} = barnchSlice.actions;
export default barnchSlice.reducer;
